'use strict'

module.exports = {
  stripeUpdateDate: new Date(2023, 2, 17),
  trialLicenses: 99999,
  getLineItems: (local) => {
    if (local) {
      return {
        starter: {
          product_id: 'prod_NUIcwLozCZmrAY',
          monthly: 'price_1MjK1ACMqGSVyfjNqpcvvSyj',
          yearly: 'price_1MjK1ACMqGSVyfjNUoOitNFz',
          licenses: 1
        },
        pro: {
          product_id: 'prod_NUIcJYuNIH0C4Y',
          monthly: 'price_1MjK1gCMqGSVyfjN6z8FruP7',
          yearly: 'price_1MjK1gCMqGSVyfjNf8krri6N',
          licenses: 1
        },
        enterprise: {
          product_id: 'prod_NUJf5fixRcSj6p',
          monthly: 'price_1MjL1rCMqGSVyfjN0jtDiZHV',
          yearly: 'price_1MjL1rCMqGSVyfjNJTwVWvyA',
          licenses: 1
        }
      }
    }
    // Production
    return {
      // starter: {
      //   product_id: 'prod_NUJqaOfFBb65jQ',
      //   monthly: 'price_1MjLfHCMqGSVyfjNHbmAZN4n',
      //   yearly: 'price_1MjLgWCMqGSVyfjNI9apZuFM',
      //   licenses: 1
      // },
      starter: {
        product_id: 'prod_NUJl9nUgpzadoS',
        monthly: 'price_1MjL7lCMqGSVyfjNG8GyHcJW',
        yearly: 'price_1MjL7lCMqGSVyfjN3Peo40iF',
        licenses: 1
      },
      pro: {
        product_id: 'prod_NUJlvIx6eCqH82',
        monthly: 'price_1MjL7tCMqGSVyfjN8SEgHiXQ',
        yearly: 'price_1MjL7tCMqGSVyfjNlUaEywyE',
        licenses: 1
      },
      enterprise: {
        product_id: 'prod_NUJlRy33Er9ksI',
        monthly: 'price_1MjL7wCMqGSVyfjNBVach5H7',
        yearly: 'price_1MjL7wCMqGSVyfjNWjl6tAdw',
        licenses: 1
      }
    }
  }
}